export default "__VITE_ASSET__DjGruU2S__"